<template>
  <a :href="artist.url">
    <div class="Artist Artist--panel">
      <div class="Artist__image-container">
        <img
          :src="artist.imageUrl"
          class="Artist__image"
        >
      </div>

      <div class="Artist__details-container">
        <h2 class="Artist__name">
          {{ artist.name }}
        </h2>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    artist: {
      default: () => {},
      type: Object,
    },
  },
};
</script>
